import { Component, computed, input } from '@angular/core';
import { ClassValue } from 'clsx';
import { bui } from '../utils/bui';

@Component({
  selector: 'sidebar-divider',
  exportAs: 'sidebarDivider',
  host: {
    '[class]': 'computedClass()',
  },
  template: ``,
})
export class SidebarDivider {
  // Inputs / Outputs
  readonly userClass = input<ClassValue>('', { alias: 'class' });

  // State
  protected readonly computedClass = computed(() =>
    bui(
      // Base
      'group/sidebar-divider',
      'flex-auto',
      'h-px grow-0',
      'bg-neutral-a4',

      // User classes
      this.userClass(),
    ),
  );
}
